import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useEntityGraphContext } from '../Wrapper/EntityGraphProvider'
import SydSelect from '../../../commonDesign/SydSelect'
import SydLabel from '../../../commonDesign/SydLabel'
import { nodeTypeListMap } from '../NodeLinkComponents/constants'
import SydButton from '../../../commonDesign/Button'

export const NodeLinkSettings = ({ nodeId }) => {
  const { state, dispatch } = useEntityGraphContext()
  const { config } = useMemo(() => state ?? {}, [state])
  const levelsAvailable = config?.nodeLinking?.levels ?? []
  const selectedItem = useMemo(() => state?.data?.nodes?.find(node => node.id === nodeId), [state, nodeId])

  const [selectedLevel, setSelectedLevel] = useState(selectedItem?.data?.entityProps?.type ?? null)
  const selectedValue = useMemo(() => selectedItem?.data?.entityProps ?? null, [selectedItem])

  const Component = useMemo(() => {
    if (!selectedLevel) return null
    return nodeTypeListMap[selectedLevel]?.component || null
  }, [selectedLevel])

  const onSelectItem = useCallback((linkData) => {
    dispatch({
      type: 'UPDATE_NODE',
      payload: {
        nodeId,
        path: ['data', 'entityProps'],
        value: linkData.entityProps
      }
    })
    dispatch({
      type: 'UPDATE_NODE',
      payload: {
        nodeId,
        path: ['data', 'displayOptions'],
        value: linkData?.displayOptions || {
          header: 'entityProps.label',
          description: 'entityProps.description'
        }
      }
    })
  }, [dispatch, nodeId])

  return (
    <div className='flex flex-col gap-2 mt-4'>
      <SydLabel label='What type of entity would you like to associate this node with?'>
        <SydSelect
          size='sm'
          options={levelsAvailable.map(level => ({
            label: nodeTypeListMap[level]?.label || level,
            value: level
          }))}
          value={selectedLevel}
          placeholder='Select an entity type'
          onChange={(e) => setSelectedLevel(e.target.value)}
          disabled={!!selectedItem?.data?.entityProps}
        />
      </SydLabel>

      {selectedLevel && Component && (
        <div className='border radius-md p-sm' style={{ overflow: 'hidden' }}>
          <Component key={selectedValue} onSelectItem={onSelectItem} actionType='linking' selectedValue={selectedValue} />
        </div>
      )}

      {!!selectedItem?.data?.entityProps && (
        <SydButton
          variant='secondary'
          size='sm'
          className='mt-2'
          onClick={() => {
            dispatch({
              type: 'UPDATE_NODE',
              payload: {
                nodeId,
                path: ['data', 'entityProps'],
                value: null
              }
            })
            setSelectedLevel(null)
          }}
        >
          Clear Linked Entity
        </SydButton>
      )}
    </div>
  )
}

NodeLinkSettings.propTypes = {
  nodeId: PropTypes.string.isRequired
}
